export default __webpack_public_path__ + "static/media/Group 1215.8131aa83.png";